import { Platform } from 'react-native';

const fixReanimatedIssue = () => {
  // FIXME remove this once this reanimated fix gets released
  // https://github.com/software-mansion/react-native-reanimated/issues/3355
  if (Platform.OS === 'web') {
    // @ts-ignore
    window._frameTimestamp = null;
  }
};

fixReanimatedIssue();
